import { Toaster } from "@/components/ui/sonner";
import UpgradeModal from "@/components/Pricing/upgrade-modal";

export default function MainLayout({ children }: { children?: any }) {
  return (
    <>
      {/* Make sure toaster appears above modals */}
      <div className="w-full h-full fixed z-[1000] pointer-events-none">
        <Toaster
          position={"top-right"}
          gap={8}
          theme={"light"}
          style={{
            // @ts-ignore
            "--width": "225px",
          }}
          duration={5000}
          toastOptions={{
            className: "pointer-events-auto",
          }}
        />
      </div>
      <div
        style={{
          width: "100vw",
          height: "100vh",
          position: "fixed",
        }}
      >
        {children}
        <UpgradeModal />
      </div>
    </>
  );
}
